import React, { useState, useEffect } from "react";
import { getBlogs_Admin, deleteBlog_Admin } from "../services/BlogAPI";

const BlogList = () => {
    const [blogs, setBlogs] = useState([]);

    useEffect(() => {
        fetchBlogs();
    }, []);

    const fetchBlogs = async () => {
        try {
            const response = await getBlogs_Admin();
            const sortedBlogs = response.data.sort((a, b) => new Date(b.createdAt) - new Date(a.createdAt));
            setBlogs(sortedBlogs);
        } catch (error) {
            console.error("Error fetching blogs:", error);
        }
    };

    const handleDelete = async (id) => {
        try {
            await deleteBlog_Admin(id);
            fetchBlogs();
        } catch (error) {
            console.error("Error deleting blog:", error);
        }
    };

    const formatDate = (date) => {
        const options = { year: 'numeric', month: 'long', day: 'numeric'};
        return new Date(date).toLocaleDateString('de-DE', options);
    };

    return (
        <table border="1" className="w-3/4 m-auto h-auto table-auto border-collapse border border-slate-500">
            <thead>
            <tr className="text-lg ">
                <th className="border border-slate-600">ID</th>
                <th className="border border-slate-600">Title</th>
                <th className="border border-slate-600">Autor</th>
                <th className="border border-slate-600">Erstellt</th>
                <th className="border border-slate-600">Bearbeitet</th>
                <th className="border border-slate-600">Aktionen</th>
            </tr>
            </thead>
            <tbody>
            {blogs.map((blog) => (
                <tr key={blog.id}>
                    <td className="border border-slate-600">{blog.id}</td>
                    <td className="border border-slate-600">{blog.title}</td>
                    <td className="border border-slate-600">{blog.author}</td>
                    <td className="border border-slate-600">{formatDate(blog.createdAt)}</td>
                    <td className="border border-slate-600">{formatDate(blog.updatedAt)}</td>
                    <td className="border border-slate-600">
                        <button className="ml-5 bg-blue-500 rounded-lg py-1 px-4 my-2 text-white hover:ring-2"
                           onClick={() => window.location.href=`/blogs/${blog.id}`}>Öffnen</button>
                        <button className="ml-5 bg-yellow-500 rounded-lg py-1 px-4 my-2 text-white hover:ring-2"
                           onClick={() => window.location.href=`/admin/blogs/edit/${blog.id}`}>Bearbeiten</button>
                        <button className="ml-5 bg-red-500 rounded-lg py-1 px-4 my-2 text-white hover:ring-2"
                           onClick={() => handleDelete(blog.id)}>Löschen</button>
                    </td>
                </tr>
            ))}
            </tbody>
        </table>
    );
};

export default BlogList;